/** @jsxImportSource @emotion/react */
import { Field } from 'formik'

type Region = { regionName: string; uuid: string }

type Props = {
  availableRegions: Region[]
  selectedRegions: string[]
  regionToAdd: string
  regionMap: Map<string, string>
  setFieldValue: (field: string, value: any) => void
}

export const KeyPersonRegionsField = ({
  availableRegions,
  selectedRegions,
  regionToAdd,
  regionMap,
  setFieldValue,
}: Props) => {
  const remainingRegions = availableRegions.filter(
    (region) => !selectedRegions.includes(region.uuid),
  )

  const canAddRegion = regionToAdd && !selectedRegions.includes(regionToAdd)

  const handleAddRegion = () => {
    if (!canAddRegion) {
      return
    }

    setFieldValue('regions', [...selectedRegions, regionToAdd])
    setFieldValue('regionToAdd', '')
  }

  const handleRemoveRegion = (regionId: string) => {
    setFieldValue(
      'regions',
      selectedRegions.filter((id) => id !== regionId),
    )
  }

  return (
    <div
      className="row mb-2"
      css={{
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '5px 10px',
      }}>
      <div className="col-6 form-group textGray">
        <label htmlFor="regionToAdd">Regions</label>
        <div className="d-flex align-items-center">
          <Field
            as="select"
            name="regionToAdd"
            className="form-control mr-2"
            value={regionToAdd}
            onChange={(e) => setFieldValue('regionToAdd', e.target.value)}
            disabled={!remainingRegions.length}>
            <option value="">Select Region</option>
            {remainingRegions.map((region) => (
              <option key={region.uuid} value={region.uuid}>
                {region.regionName}
              </option>
            ))}
          </Field>
          <i
            onClick={handleAddRegion}
            className="fa fa-plus-circle ml-2"
            aria-hidden="true"
            css={{
              cursor: canAddRegion ? 'pointer' : 'not-allowed',
              color: canAddRegion ? '#2c83bd' : '#ccc',
            }}
          />
        </div>
      </div>
      <div className="col-6" css={{ overflowY: 'auto', maxHeight: 150 }}>
        {!!selectedRegions.length ? (
          <table className="table" css={{ '& td, th': { padding: '0.25rem' } }}>
            <thead>
              <tr>
                <th>Region</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {selectedRegions.map((regionId) => (
                <tr key={regionId}>
                  <td>{regionMap.get(regionId) ?? regionId}</td>
                  <td>
                    <i
                      onClick={() => handleRemoveRegion(regionId)}
                      className="fa fa-times-circle ml-2"
                      aria-hidden="true"
                      css={{ cursor: 'pointer', color: '#2c83bd' }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div css={{ color: '#6D757E', fontSize: 12 }}>No regions linked</div>
        )}
      </div>
    </div>
  )
}
